import { createSubscriptionPayment } from '@/api/query/payment';
import { useLanguageData } from '@/common/hooks/useLanguageData';
import { formatTranslation } from '@/common/utils/formatTranslation';
import { BLIK_FIRST_PAYMENT_METHOD_ORDER } from '@/pages/customer/pawall/stripe/stripePaymentElementOptions';
import PlanPaymentElements from '../../../components/planPayment/PlanPaymentElements';
import { getIsBlikRejected } from './helpers/getIsBlikRejected';

const StripeSubscriptionPayment = ({
	selectedPlan,
	returnPath,
	analyticsSource,
	onBlikRejected,
}) => {
	const t = useLanguageData('chat');

	const handleConfirmError = (error) => {
		if (getIsBlikRejected(error)) {
			onBlikRejected?.();
		}
	};

	return (
		<PlanPaymentElements
			selectedPlan={selectedPlan}
			createPayment={createSubscriptionPayment}
			returnPath={returnPath}
			analyticsSource={analyticsSource}
			submitLabel={formatTranslation(t.planCheckoutSubscribe, {
				price: selectedPlan.price,
			})}
			processingLabel={t.planCheckoutCreatingSubscription}
			termsPrefix={t.planCheckoutSubscribeTermsPrefix}
			paymentMethodOrder={BLIK_FIRST_PAYMENT_METHOD_ORDER}
			onConfirmError={handleConfirmError}
		/>
	);
};

export default StripeSubscriptionPayment;
